import { message, Upload } from "antd";
import { useEffect, useState } from "react";
import type { UploadProps, UploadFile } from "antd/es/upload/interface";
import { authAxios, getTokenFromSessionStorage, getEmailFromSessionStorage } from "../../../utils/session_utils";
import { v4 as uuidv4 } from "uuid";
import { Form } from "antd";


const useEPGInputsUploadHook = () => {
    // const [fileList, setFileList] = useState<UploadFile[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
    const [redirectToBatchJobs, setRedirectToBatchJobs] = useState<boolean>(false);
    const [uploadUUID, setUploadUUID] = useState<string>(uuidv4());
    const [channelName, setChannelName] = useState<string>('Nosey');
    const [allFilesUploaded, setAllFilesUploaded] = useState<boolean>(false);
    const [form] = Form.useForm();
    
    useEffect(() => {
        console.log("uploadUUID", uploadUUID);
        console.log("channelName", channelName);
        form.setFieldsValue({ uploadUUID, channelName });
    }, [uploadUUID, channelName]);


    const uploadProps: UploadProps = {
        accept: ".csv",
        name: 'file',
        multiple: true,
        action: `${process.env.REACT_APP_BACK_END_API}/epg-generator/upload`,
        withCredentials: true,
        headers: {
            authorization: `Bearer ${getTokenFromSessionStorage()}`,
        },
        data: {
            uploadUUID,
            channelName,
        },
        showUploadList: {
            showDownloadIcon: false,
            showRemoveIcon: false,
        },
        onChange(info: any) {
            const { status } = info.file;
            if (status === 'done') {
                let fileDoneCount = 0;
                info.fileList.forEach((file: UploadFile) => {
                    if(file.status === 'done') {
                        fileDoneCount++;
                    }
                });
                if(fileDoneCount === info.fileList.length) {
                    message.success(`${info.fileList.length} file uploaded successfully.`);
                    setAllFilesUploaded(true);
                }
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e: React.DragEvent<HTMLElement>) {
            console.log('Dropped files', e.dataTransfer.files);
            return true;
        },
    };

	const handleSubmit = async () => {
        if(!allFilesUploaded) {
            message.error("Please upload all files before submitting");
            return;
        }
        setLoading(true);
        const toEmail = getEmailFromSessionStorage();
        
        if (toEmail?.length === 0 || !toEmail?.endsWith("mvmediasales.com")) {
			message.error("Please enter a valid mvmediasales email address");
		} else {
			setLoading(true);
            try {
				const config = {
					method: "POST",
					url: `${process.env.REACT_APP_BACK_END_API}/epg-generator/submit-job`,
					data: {
                        uploadUUID,
                        channelName,
                        toEmail,
                    },
					headers: { accept: "application/json", "content-type": "application/json" },
				};
				const response = await authAxios(config);
				if (!response.data.err) {
					message.success(response.data.message);
					setRedirectToBatchJobs(true);
				} else {
					message.error("Something went wrong");
				}
				setLoading(false);

				// console.log(response.data); // Handle the response from the Node.js app
			} catch (error) {
				setLoading(false);
				console.error(error);
			}
        }
    };

    return { loading, handleSubmit, uploadProps, uploadUUID, channelName, form, redirectToBatchJobs };
};

export default useEPGInputsUploadHook;
